// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-strength/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springStrengthEN: PageEntry = {
  id: "post.federfestigkeit",
  locale: "en",
  slug: "spring-strength",
  seo: {
    title: "Glossary: Spring strength explained simply | Dietz GmbH",
    description: "Spring strength refers to the ability of a spring to withstand loads and deformations without suffering permanent damage. This parameter is crucial for the service life and reliabi",
  },
  type: "post",
  h1: "Glossary: Spring strength explained simply",
  intro: "Spring strength refers to the ability of a spring to withstand loads and deformations without suffering permanent damage. This parameter is crucial for the service life and reliability of a spring in a particular system. The strength of a spring depends on various factors, including the spring material used, the spring design and the quality of manufacturing. A precise knowledge of spring strength enables engineers to design springs to meet the specific requirements of an application while ensuring a long service life.",
  blocks: [

  ],
};
